import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { useLoc } from "@/lib/loc";
import VideoCard from "@/components/VideoCard";
import Seo from "@/components/Seo";
import { Loader2 } from "lucide-react";

export default function CreatorPage() {
  const { slug } = useParams();
  const loc = useLoc();

  const { data, isLoading } = useQuery({
    queryKey: ["creator", slug],
    queryFn: async () => (await api.get(`/creators/${slug}`)).data,
  });

  if (isLoading)
    return (
      <div className="flex h-screen items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  if (!data) return null;
  const { creator, videos } = data;

  return (
    <div className="min-h-screen pb-16">
      <Seo title={creator.name} description={loc(creator.bio)} image={creator.cover_url} />
      <div className="relative h-[46vh] min-h-[320px] w-full">
        <img src={creator.cover_url} alt={creator.name} className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 hero-fade" />
        <div className="relative z-10 mx-auto flex h-full max-w-[1600px] items-end px-6 pb-8 md:px-12">
          <div className="flex items-center gap-5">
            <img src={creator.avatar_url} alt={creator.name} className="h-24 w-24 rounded-full object-cover ring-2 ring-primary/40 md:h-28 md:w-28" />
            <div>
              <h1 className="font-heading text-3xl font-bold tracking-tight md:text-4xl">{creator.name}</h1>
              <p className="text-primary">{loc(creator.title)}</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-[1600px] px-6 md:px-12">
        <p className="mt-6 max-w-3xl leading-relaxed text-white/70">{loc(creator.bio)}</p>
        <div className="mt-8 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {videos?.map((v) => (
            <VideoCard key={v.id} video={v} className="w-full" />
          ))}
        </div>
      </div>
    </div>
  );
}
